import { useEffect } from 'react';
import { Outlet, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import type { RootState, AppDispatch } from '../../../../store/store';
import { getFromLocalStorage } from '../../../../store/UserSlice';
import Header from '../../../shared/Header/Header';
import Footer from '../../../shared/Footer/Footer';
import BannerCarousel from '../../../HomePage/bannerCarousel/BannerCarousel';
import ShowcaseMain from '../../../layouts/showcaseLayouts/ShowcaseMain/ShowcaseMain';
import useIsLTE650 from '../../../../hooks/useIsLTE650';
import classes from './ShowcasePage.module.css';

const ShowcasePage: React.FC = () => {
    const { url } = useParams();
    const isDiscountsRoute = url === 'discounts';
    const { isAuthenticated } = useSelector((state: RootState) => state.auth);
    const dispatch = useDispatch<AppDispatch>();
    const isMobile = useIsLTE650(650);

    useEffect(() => {
        if (isAuthenticated) {
            dispatch(getFromLocalStorage('wishlist'));
            dispatch(getFromLocalStorage('cart'));
        }
    }, [isAuthenticated, dispatch]);

    return isDiscountsRoute ? (
        <div className={classes.showcase}>
            <Header isMobile={isMobile} />
            <div className="homePage__main homePage__main_showcaseDiscounts">
                <BannerCarousel isMobile={isMobile} />
            </div>
            <ShowcaseMain>
                <>
                    <Outlet />
                </>
            </ShowcaseMain>
            <Footer isMobile={isMobile} />
        </div>
    ) : (
        <div className={classes.showcase}>
            <Header isMobile={isMobile} />
            <ShowcaseMain>
                <>
                    <Outlet />
                </>
            </ShowcaseMain>
            <Footer isMobile={isMobile} />
        </div>
    );
};

export default ShowcasePage;
